export default __webpack_public_path__ + "static/media/480_store04-fr-mobile.cd507c9d.png";